import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlugin2"><Path d="M4 3H11V6H4V3Z" fill="currentColor"/><Path d="M13 3H20V6H13V3Z" fill="currentColor"/><Path d="M2 8H22V20H2V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin2;
